/** @module csi/breadcrumb/RevisionVersionDropDownButton */
define([
	"dojo/_base/declare",
	"dojo/when",
	"dijit/form/DropDownButton",
	"dijit/MenuItem",
	"underscore",
	"csi/action",
	"csi/locale",
	"csi/reflection",
	"csi/store/Nodes",
	"csi/widget/DropDownMenu",
	"csi/xml",
	"csi/xml/Query"
], function(declare,when,DropDownButton,MenuItem,_,csiAction,locale,reflection,Nodes,DropDownMenu,xml,Query) {

	return declare(DropDownButton, {
		/** @property {Action} revisionAction - Action to select explicit version */
		revisionAction: null,

		/** @property {string} revisionType - Type of the revision */
		revisionType: "",

		/** @property {csi.view.Widget} view - Breadcrumb view */
		view: null,

		/**
		 * @override
		 * Initialize versions based on currently displayed master
		 */
		postCreate: function() {
			const view = this.view;
			const revisionNode = view.getRevisionNode();

			this.set("label", locale.resource("Version") + " " + revisionNode.Version);
			this.inherited(arguments);
		},

		/**
		 * @override
		 * Force the call to "loadDropDown" as needed
		 */
		isLoaded: function() {
			return !!this.get("dropDown");
		},

		/**
		 * @override
		 * Initialize versions based on currently displayed master
		 */
		loadDropDown: function(loadCallback) {
			const view = this.view;
			const master = view.getViewNode();
			const revisionNode = view.getRevisionNode();
			const revisionAction = this.revisionAction;
			const dropDown = new DropDownMenu();
			this.set("dropDown", dropDown);
			const limitPath = xml.getUrlPath(master.$URL, xml.path(reflection.ATTR_REVISIONS));

			const store = new Nodes({
				cachingStore: view.cacheView,
				requestParameters: {
					"Qry.Limit.Path": limitPath
				},
				filterQuery: new Query()
					.Attr(reflection.ATTR_STATE, xml.OP_NOT_EQUALS, reflection.REVISION_DRAFT),
				sortQuery: new Query().SortByNode("Version"),
				typeNode: this.revisionType
			});

			when(store.query(), function(results) {
				_.each(results, function(revision) {
					const url = revision.$URL;
					const bActive = (url == revisionNode.$URL);

					dropDown.addChild(new MenuItem({
						"class": "csi-menu-item-with-icon",
						iconClass: bActive ? "csi-checked-menu-item-check" : null,
						disabled: !xml.isValidURL(url),
						label: locale.resource("Version") + " " + revision.Version,
						onClick: function() {
							csiAction.invoke(view, view.domNode, revisionAction, {actionValue: url});
						}
					}));
				});

				loadCallback();
			});
		}
	});
});